import { ErrorBoundary } from 'react-error-boundary'
import { Outlet, useNavigation } from 'react-router'

export default function Layout() {
  const navigation = useNavigation()
  return (
    <main>
      {navigation.state === 'loading' && (
        <div className="w-full bg-blue-100 border-b border-blue-200 py-2 px-4">
          <p className="text-blue-700 text-sm">正在加载数据...</p>
        </div>
      )}

      {navigation.state === 'submitting' && (
        <div className="w-full bg-green-100 border-b border-green-200 py-2 px-4">
          <p className="text-green-700 text-sm">正在提交数据...</p>
        </div>
      )}

      <ErrorBoundary
        fallback={<p>⚠️Something went wrong</p>}
        onError={(error, info) => {
          console.error('组件错误:', error)
          console.error('错误信息:', info)
        }}>
        {/* 使用Outlet渲染子路由 */}
        <Outlet />
      </ErrorBoundary>
    </main>
  )
}
